import { AddIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { Container } from 'components/Container';
import { ContainerHead } from 'components/ContainerHead';
import { DataTable } from 'components/DataTable/DataTable';
import { placesTable } from 'components/DataTable/DataTableModels';
import { useApi } from 'lib/useApi';
import { Place } from 'models/ApiModels';
import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';

export function PlacesPage(): JSX.Element {
  const { data: places } = useApi<Place[]>(`/places`);

  return (
    <>
      <ContainerHead title="Platser" children="" />
      <Container>
        <Link to={routes.createPlace.path}>
          <Button variant="primary" mb={10}>
            <AddIcon mr={3} />
            {routes.createPlace.linkText}
          </Button>
        </Link>
        <DataTable
          title="Platser"
          tableDef={placesTable}
          data={places}
          showSearch={true}
          searchableFields={['name']}
        />
      </Container>
    </>
  );
}
